// import request from '@/utils/requests'
import axios from './http'

export function allUser (token , userSupplierId) {
  return axios({
    url: '/api/supplier/allUser',
    headers: {
      'authorization': token,
      'userSupplierId': userSupplierId
    },
    method: 'get'
  })
}

export function cacheExcel (token, params, managerId) {
  return axios({
    url: '/api/data-center/report-cache-excel',
    headers: {
      'authorization': token,
      'managerId': managerId
    },
    method: 'post',
    data: params
  })
}

export function excel (token, cacheId) {
  return axios({
    method: 'post',
    url: '/api/data-center/report-detail-excel',
    responseType: 'blob',
    headers: {
      'authorization': token
    },
    data: {
      cacheId: cacheId
    }
  })
}
export function Mailselect (token) {
  return axios({
    method: 'post',
    url: '/api/data-center-Mail/MailSelect',
    headers: {
      'authorization': token
    }
  })
}
export function Mail (token, params,managerId) {
  return axios({
    method: 'post',
    url: '/api/data-center-Mail/report-detail-Mail',
    responseType: 'blob',
    headers: {
      'authorization': token,
      'managerId': managerId
    },
    data: params
  })
}

export function unsettleExcel(token,params,managerId){
  return axios({
    method: 'post',
    url: '/api/data-center/report-detail-excel-unsettle',
    responseType: 'blob',
    headers: {
      'authorization': token,
      'managerId':managerId
    },
    data: params
  })
}

// 导出业务员名单数据
export function createReportSalesmanExcel(token,params,managers){
  return axios({
    method: 'post',
    url: '/api/supplier/report-supplier-salesman-excel/'+managers,
    responseType: 'blob',
    headers: {
      'authorization': token
    },
    data: params
  })
}


// 业务员名单上传
export function putMessageLevelExcel(token,supplierId, params){
  return axios({
    method: 'post',
    url: '/api/supplier/put-message-level-excel',
    headers: {
      'authorization': token,
      'supplierId' : supplierId,
      'Content-Type':'multipart/form-data'
    },
    data: params
  })
}

export function getSupplierInfoByUserId (token,managers) {
  return axios({
    method: 'get',
    url: '/api/supplier/getSupplierInfoByUserId/'+managers,
    headers: {
      'authorization': token
    }
  })
}

export function getManager (token) {
  return axios({
    url: '/api/supplier/getManager',
    headers: {
      'authorization': token
    },
    method: 'get'
  })
}

// 对接业务员中供应商选择
export function getUserSupplier (token) {
  return axios({
    url: '/api/supplier/getUserSupplier',
    headers: {
      'authorization': token
    },
    method: 'get'
  })
}

// 对接业务员中供应商选择
export function querySupplierManagerConfig(token, supplierId) {
  return axios({
    url: '/api/supplier/querySupplierManagerConfig',
    headers: {
      'authorization': token,
      'supplierId': supplierId
    },
    method: 'POST',
  })
}

// 对接业务员中供应商选择
export function submitSupplierManagerConfig(token, data) {
  return axios({
    url: '/api/supplier/updateSupplierManagerConfig',
    headers: {
      'authorization': token
    },
    method: 'POST',
    data: data
  })
}

export function queryReportDetail(token, params, managerId) {
  return axios({
    url: '/api/data-center/query-report-detail',
    headers: {
      'authorization': token,
      'managerId': managerId
    },
    method: 'post',
    data: params
  })
}

export function queryWeeklyReport(token, params, managerId) {
  return axios({
    url: '/api/data-center/query-weekly-report',
    headers: {
      'authorization': token,
      'managerId': managerId
    },
    method: 'post',
    data: params
  })
}

export function downloadDataJson(fileName) {
  return axios({
    url: 'https://img2.orangev.cn/data_center_excel/' + fileName,
    method: 'get',
    headers: {
      'Accept': '*/*'
    }
  })
}
